import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export const COMPANY_ID_PARAMS = {
  new: 'new',
  users: 'users',
  subCompany: 'sub-company',
};

export const COMPANIES_ROUTING_PARAMS = {
  companyId: 'companyId',
  subCompanyId: 'subCompanyId',
  userId: 'userId',
  tabName: 'tabName',
};

export class CompaniesPaths {
  static companies = new EnhancedPath('/companies');

  static companiesSubCompanyUserTab = new EnhancedPath(
    `${CompaniesPaths.companies.path}/:${COMPANIES_ROUTING_PARAMS.companyId}/${COMPANY_ID_PARAMS.subCompany}/:${COMPANIES_ROUTING_PARAMS.subCompanyId}/${COMPANY_ID_PARAMS.users}/:${COMPANIES_ROUTING_PARAMS.userId}/:${COMPANIES_ROUTING_PARAMS.tabName}?`,
  );

  static companiesUserTab = new EnhancedPath(
    `${CompaniesPaths.companies.path}/:${COMPANIES_ROUTING_PARAMS.companyId}/${COMPANY_ID_PARAMS.users}/:${COMPANIES_ROUTING_PARAMS.userId}/:${COMPANIES_ROUTING_PARAMS.tabName}?`,
  );

  static companiesTab = new EnhancedPath(
    `${CompaniesPaths.companies.path}/:${COMPANIES_ROUTING_PARAMS.companyId}/:${COMPANIES_ROUTING_PARAMS.tabName}?`,
  );
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: CompaniesPaths.companiesSubCompanyUserTab.path,
      component: lazyWithRetry(() => import('app/pages/system/users/user')),
    },
    {
      path: CompaniesPaths.companiesUserTab.path,
      component: lazyWithRetry(() => import('app/pages/system/users/user')),
    },
    {
      path: CompaniesPaths.companiesTab.path,
      component: lazyWithRetry(() => import('app/pages/companies/companies/company')),
    },
    {
      path: CompaniesPaths.companies.path,
      component: lazyWithRetry(() => import('app/pages/companies/companies')),
      pageCode: PAGE_CODES.INTERNAL_COMPANIES,
    },
  ],
};

export default routesConfig;
